import React, { useCallback, useState } from 'react';
import { Box, Container } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import Page from 'src/components/Page';
import { useDispatch } from 'react-redux';
import {
  createCompanyAction,
  deleteCompanyAction,
  editCompanyAction
} from 'src/store/actions/catalogActions';
import { useTranslation } from 'react-i18next';
import CompanyList from './CompanyList';
import Toolbar from '../Toolbar';
import CompanyForm from './CompanyForm';

const useStyles = makeStyles()(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const CompaniesListView = () => {
  const { classes }  = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);

  const handleClose = useCallback(() => {
    setOpen(false);
    setData(null);
  }, [setOpen, setData]);

  const handleOpen = useCallback(() => {
    setOpen(true);
  }, [setOpen]);

  const handleOpenEdit = useCallback(
    values => {
      setOpen(true);
      setData(values);
    },
    [setOpen, setData]
  );

  const handleCreate = useCallback(
    values => {
      dispatch(createCompanyAction(values));
      handleClose();
    },
    [handleClose, dispatch]
  );

  const handleEdit = useCallback(
    values => {
      dispatch(editCompanyAction(values));
      handleClose();
    },
    [handleClose, dispatch]
  );

  const handleDelete = useCallback(
    id => {
      dispatch(deleteCompanyAction(id));
      handleClose();
    },
    [handleClose, dispatch]
  );

  return (
    <Page
      className={classes.root}
      title={t('NAVIGATION.CATALOG_LIST.COMPANIES')}
    >
      <Container maxWidth={false}>
        <Toolbar
          catalogLabel={t('NAVIGATION.CATALOG_LIST.COMPANIES')}
          handleOpen={handleOpen}
        />
        <Box mt={3}>
          <CompanyList
            handleOpenEdit={handleOpenEdit}
            handleDelete={handleDelete}
          />
        </Box>
      </Container>
      <CompanyForm
        open={open}
        data={data}
        handleClose={handleClose}
        handleCreate={handleCreate}
        handleEdit={handleEdit}
      />
    </Page>
  );
};

export default CompaniesListView;
